import { useState, useEffect } from "react";
import { supabase } from "../supabase";
import "../App.css"; // main CSS


export default function DriverDashboard() {
  const [view, setView] = useState("new");
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [profile, setProfile] = useState(null);
  const filteredOrders = orders.filter((o) =>
  view === "new" ? o.status === "En attente" : true
);


  // Check session on load
  useEffect(() => {
    supabase.auth.getSession().then(({ data }) => {
      if (data.session) setUser(data.session.user);
      
    });
  }, []);

  // Fetch orders + realtime
  useEffect(() => {
    if (!user) return;

    fetchOrders();

    const channel = supabase
      .channel(`driver-orders-${user.id}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "orders" },
        () => fetchOrders()
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [user]);

  const fetchOrders = async () => {
    const { data, error } = await supabase
      .from("orders")
      .select("*")
      .eq("driver_id", user.id)
      .order("created_at", { ascending: false });

    if (error) console.log("Erreur lors du chargement des commandes:", error.message);
    else setOrders(data);
  };

  const handleLogin = async () => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) setErrorMsg(error.message);
    else {
      setErrorMsg("");
      setUser(data.user);
    }
  };

  const handleLogout = async () => {
    await supabase.auth.signOut();
    setUser(null);
    setOrders([]);
  };

  const markComplete = async (orderId) => {
  const { error } = await supabase
    .from("orders")
    .update({
      status: "Terminé",
      completed_at: new Date().toISOString(),
    })
    .eq("id", orderId);

  if (error) {
    console.log("Erreur lors de la mise à jour:", error.message);
  }
};


  // Login form
  if (!user) {
    return (
      <div className="driver-page">
        
        <div className="driver-login">
          <h2>Connexion Livreur</h2>
          {errorMsg && <p className="error">{errorMsg}</p>}

          <div className="field">
            <label>Email</label>
            <input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="livreur@example.com"
            />
          </div>

          <div className="field">
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Mot de passe"
            />
          </div>

          <button className="primary" onClick={handleLogin}>
            Se connecter
          </button>
        </div>
      </div>
    );
  }

  // Driver dashboard
  return (
    <div className="driver-page">
      <header className="topbar">
  <h1 className="topbar-title">Watamin • {user.email} </h1>

  <button className="ghost" onClick={() => setView("new")}>
    Nouvelles commandes
  </button>

  <button className="ghost" onClick={() => setView("all")}>
    historique commandes
  </button>

  <button className="ghost logout-btn" onClick={handleLogout}>
    Déconnexion
  </button>
</header>


      <main className="driver-content">
        <section className="driver-section">
          <h2 className="section-title">Commandes assignées</h2>

          {filteredOrders.length === 0 ?  (
            <p className="empty">Aucune commande assignée pour le moment.</p>
          ) : (
            <div className="table-wrapper">
              <table className="orders-table">
                <thead>
                  <tr>
                    
                    <th>N°</th>
                    <th>Tél. client</th>
                    <th> Nom du Client</th>
                    <th>Nom Destinataire</th>
                    <th>Tél. Destinataire</th>
                    <th>Type Colis</th>
                    <th>Valeur colis</th>
                    <th>Collecte</th>
                    <th>Livraison</th>
                    <th>Prix</th>
                    <th>Paiement</th>
                    <th>payé par</th>
                    <th>Statut</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredOrders.map((o) => (

                    
                    <tr key={o.id}>
                    <td>{o.order_code}</td>
                <td>{o.phone}</td>
                <td>{o.client_name}</td>
                <td>{o.recipient_name}</td>
                <td>{o.recipient_phone}</td>
                <td>{o.package_type}</td>
                <td>{o.package_price}</td>
                <td>{o.pickup}</td>
                <td>{o.delivery}</td>
                <td>{o.price} FCFA</td>
                <td>{o.payment_method}</td>
                <td>{o.delivery_fee_payer}</td>
                
                      <td>
                        <span className={`status ${o.status || "pending"}`}>
                          {o.status || "en attente"}
                        </span>
                      </td>
                      <td>
                        {o.status !== "Terminé" && (
                          <button
                            className="primary"
                            onClick={() => markComplete(o.id)}
                          >
                            Terminer
                          </button>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </main>
    </div>
  );
}

